module.exports = __webpack_public_path__ + "img/homefoodlogo.1539e306.png";